import customHeaders, { getSpace } from '../../common/headers';
import { TableBox } from '@lk-gtcom/ecomlab-components';
import { MoonLoader } from 'react-spinners';
import { Link, useParams } from 'react-router-dom';
import { RavshanArticlesHttps } from '../../fetchUrls';
import { useState, useEffect, useRef } from 'react';
import {
  usePagination,
  ArticleMinBox,
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './ArticleMain.scss';

const ArticleMain = ({
  selectedEndLevelValue,
  selectedPortalValue,
  activeLang,
  pathBread,
  selectView,
  search,
  setSelectedTags,
  selectedTags,
  setTotalParent,
  sortingRef,
  selectedState,
  paths,
  isEditor,
  fetchGetBreadcrumbs,
  onDragStartDropArticle,
  onDragOverDropArticle,
  dragArticle = null,
  isPin,
  isFavorite
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const path = useParams()['*'];
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState({ data: [], label: {} });

  const [waiting, setWaiting] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [notifications, setNotifications] = useState([]);

  const paginatorRef = useRef();
  const paginatorCallback = useRef();
  const tableFetchCallback = useRef();
  const tagsRef = useRef();

  const isBaseRoute = paths?.length === 0;

  const tableHeaders = articles?.labels;
  const tableData = articles?.data;

  const [columnSize, setColumnSize] = useState([]);
  const [sort, setSort] = useState({});

  const articleIdIndex = tableHeaders?.header.findIndex((h) => h === 'id');

  const [
    page,
    limit,
    total,
    setTotal,
    Paginator,
    resetPaginator,
    paginatorTransition,
  ] = usePagination(
    paginatorCallback.current,
    [],
    paginatorRef.current?.params
  );

  const checkArticleStatus = (articleId) => {
    const _headers = {
      ...headers,
      'article-id': articleId,
      Accept: 'application/json',
    };
    return fetch(`${RavshanArticlesHttps}/get_article_status`, {
      headers: _headers,
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json()
        } else {
          const err = await res.json()
          throw new Error(JSON.stringify(err))
        }
      })
      .catch(err => console.error(err))
  };

  const saveWidthColumn = () => {
    if (selectView == 'Table') {
      const colWidth = [...document.querySelectorAll('.col-th-border')];
      if (colWidth.length > 0) {
        const arrWidth = colWidth.map((el) =>
          el.style.width ? el.style.width : '247px'
        );
        sessionStorage.setItem('col-width', arrWidth);
      }
    }
  };

  const fetchArticlesByLevel = (value, page, limit, params) => {
    saveWidthColumn();
    const abortController = new AbortController();
    // setArticles({ data: [], label: {} });
    setLoading(true);
    const url = `${RavshanArticlesHttps}/get_articles_by_parents`;

    let filters = null,
      sorting = null;
    if (params?.length) {
      [sorting, filters] = params;
    }
    if (sorting) setSort(sorting);

    const orderParam =
      selectView === 'Table'
        ? sorting?.length
          ? sorting[0]
          : ''
        : sortingRef.current
          ? sortingRef.current.param
          : '';
    const orderParamDirection =
      selectView === 'Table'
        ? sorting?.length
          ? sorting[1]
          : ''
        : sortingRef.current
          ? sortingRef.current.direction
          : '';

    const getHeaders = {
      ...headers,
      'level-id': value,
      language: activeLang?.toLowerCase(),
      page: page,
      limit: limit ?? 10,
      active: true,
      status: selectedState?.value,
    };

    if (orderParam)
      Object.assign(getHeaders, { 'order-param': btoa(encodeURI(orderParam)) });
    if (orderParamDirection)
      Object.assign(getHeaders, {
        'order-param-direction': orderParamDirection,
      });
    if (filters)
      Object.assign(getHeaders, {
        filters: btoa(encodeURI(JSON.stringify({ filters }))),
      });

    fetch(url, { headers: getHeaders, signal: abortController.signal })
      .then(async (res) => {
        if (res.ok) {
          return res.json()
        } else {
          const err = await res.json()
          throw new Error(JSON.stringify(err))
        }
      })
      .then((json) => {

        if (!Object.entries(json).length) return;
        setArticles(json);
        localStorage.setItem('articles', JSON.stringify(json))
        setTotal(json.total);
        setTotalParent(json.total);
        setColumnSize(json.column_size);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
    // return abortController;
  };

  const fetchAllPortalsArticles = (value, page, limit, params) => {
    saveWidthColumn();
    const abortController = new AbortController();
    setLoading(true);
    const url = `${RavshanArticlesHttps}/api/v2/article/get_articles_by_parent`;

    let filters = null,
      sorting = null;
    if (params?.length) {
      [sorting, filters] = params;
    }
    if (sorting) setSort(sorting);

    const orderParam =
      selectView === 'Table'
        ? sorting?.length
          ? sorting[0]
          : ''
        : sortingRef.current
          ? sortingRef.current.param
          : '';
    const orderParamDirection =
      selectView === 'Table'
        ? sorting?.length
          ? sorting[1]
          : ''
        : sortingRef.current
          ? sortingRef.current.direction
          : '';

    const body = JSON.stringify({
      level_id: value,
      search: search,
      language: activeLang?.toLowerCase(),
      active: true,
      // readed: true,
      page: page,
      limit: limit ?? 10,
      view: "table",
      order_param_direction: orderParamDirection?.toLowerCase() || 'desc',
      order_param: orderParam || 'date',
      filters: filters,
      status: selectedState?.value,
      is_favorite: isFavorite,
      is_pin: isPin
    })

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(async (res) => {
        if (res.ok) {
          return res.json()
        } else {
          const err = await res.json()
          throw new Error(JSON.stringify(err))
        }
      })
      .then((json) => {
        if (!Object.entries(json).length) return;
        setArticles(json);
        localStorage.setItem('articles', JSON.stringify(json))
        setTotal(json.total);
        setTotalParent(json.total);
        setColumnSize(json.column_size);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
    // return abortController;
  };

  useEffect(() => {
    setInitialRender(false);
  }, []);

  useEffect(() => {
    if (
      isBaseRoute &&
      selectedTags?.length === 0 &&
      tagsRef.current !== selectedTags &&
      !initialRender
    ) {
      paginatorCallback.current = (filters) =>
        fetchAllPortalsArticles(null, page, limit, filters);
      tableFetchCallback.current = (filters) =>
        fetchAllPortalsArticles(null, page, limit, filters);
      fetchAllPortalsArticles(null, 1, limit, paginatorRef.current?.params);
    }
    tagsRef.current = selectedTags;
  }, [selectedTags?.length, selectView, page, limit]);

  useEffect(() => {
    if (selectedPortalValue) {
      paginatorCallback.current = (filters) =>
        fetchAllPortalsArticles(selectedPortalValue, page, limit, filters);
      // tableFetchCallback.current = (filters) => fetchAllPortalsArticles(selectedPortalValue, page, limit, filters)
      fetchAllPortalsArticles(selectedPortalValue, page, limit);
      fetchGetBreadcrumbs(selectedPortalValue)
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (dragArticle) return
    if (waiting) setWaiting(false);
    if (isBaseRoute || paginatorTransition) return;
    if (selectedPortalValue) {
      paginatorCallback.current = (filters) =>
        fetchAllPortalsArticles(selectedPortalValue, page, limit, filters);
      // tableFetchCallback.current = (filters) => fetchAllPortalsArticles(selectedPortalValue, page, limit, filters)
      fetchAllPortalsArticles(selectedPortalValue, page, limit);
      fetchGetBreadcrumbs(selectedPortalValue)
      window.scrollTo(0, 0);
    } else if (selectedEndLevelValue) {
      paginatorCallback.current = (filters) =>
        fetchArticlesByLevel(selectedEndLevelValue, page, limit, filters);
      fetchGetBreadcrumbs(selectedEndLevelValue)
      tableFetchCallback.current = (filters) =>
        fetchArticlesByLevel(selectedEndLevelValue, page, limit, filters);
      fetchArticlesByLevel(
        selectedEndLevelValue,
        page,
        limit,
        paginatorRef.current?.params
      );
      fetchGetBreadcrumbs(selectedEndLevelValue)
    }
    // оба уровня не могут быть равны нулю если адрес страницы отличается от дефолтного, поэтому ждём пока прогрузится сайдбар
    else {
      setTimeout(setWaiting(true), 1000);
      return;
    }
  }, [
    path,
    waiting,
    selectedEndLevelValue,
    selectedPortalValue,
    isPin,
    isFavorite,
    paginatorTransition,
    activeLang,
    selectView,
    limit,
    selectedState,
    search,
    dragArticle
  ]);

  useEffect(() => {
    if (isBaseRoute) {
      paginatorCallback.current = (filters) =>
        fetchAllPortalsArticles(null, page, limit, filters);
      // tableFetchCallback.current = (filters) => fetchAllPortalsArticles(null, page, limit, filters)
      fetchAllPortalsArticles(null, 1, limit, paginatorRef.current?.params);
      setSelectedTags([]);
    }
    resetPaginator();
  }, [path, activeLang, selectView, selectedState]);

  useEffect(() => {
    if (typeof paginatorCallback.current === 'function' && !initialRender) {
      paginatorCallback.current(page, limit);
    }
  }, [sortingRef.current]);

  return (
    <div className="article-main">
      <div className="notifications-portal">
        {notifications.map((n) => n.component)}
      </div>

      <div className="content-and-filter">
        {
          <>
            {selectView === 'Table' ? (
              <div className="table-box">
                <TableBox
                  ref={paginatorRef}
                  fetchedData={tableData}
                  headers={tableHeaders}
                  columnSize={columnSize}
                  fetchCallback={(e) => {
                    resetPaginator()
                    tableFetchCallback.current(e);
                  }}
                  sort={sort}
                  loading={loading}
                // paginator={true}
                />
                {Paginator}
              </div>
            ) : loading ? (
              <div className="loader-box">
                <MoonLoader
                  className="loader"
                  color="#7b7b7b"
                  speedMultiplier={0.5}
                  size={65}
                />
              </div>
            ) : (
              <ArticleMinBox
                pathArticles='/ru'
                pathBread={pathBread}
                articlesData={articles}
                selectView={selectView}
                paginator={Paginator}
                showStatus={true}
                activeLang={activeLang}
                wiki={true}
                readOnly={!isEditor}
                onDragStart={(e) => onDragStartDropArticle(e)}
                onDragOver={(e) => onDragOverDropArticle(e)}
              />
            )}
          </>
        }
      </div>
    </div>
  );
};

export { ArticleMain };
